import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { ISortIndexItem } from '@fi-shared/fi-shared-interfaces';
import { ObjectTypes } from '@fi-shared/types';

@Injectable()
export class FiCommonSharedService {
    constructor(private fiBackend: FiBackendService) {}

    updateSortIndexes(items: ISortIndexItem[], objectType: ObjectTypes) {
        const sortIndexData: ISortIndexItem[] = [];
        items.forEach((item, idx) => {
            if (idx !== item.SortIndex) {
                sortIndexData.push({
                    Id: item.Id,
                    SortIndex: idx,
                });
            }
        });
        if (sortIndexData.length) {
            this.fiBackend.fetchDataPost(`Core/Common/UpdateSortIndexes/${objectType}`, sortIndexData).then(() => {
                items.forEach((item, idx) => {
                    item.SortIndex = idx;
                });
            });
        }
    }
}
